export const config = {
  globals: {
    React: () => import('react'),
    ReactDOM: () => import('react-dom'),
    axios: () => import('axios'),
    styled: () => import('styled-components'),
    styledComponents: () => import('styled-components'),
    nanoid: () => import('nanoid'),
  },
  files: [
    [
      'ContactFlowModule',
      [
        {
          component: 'default',
          core: true,
          default: {
            // file: 'http://localhost:5000/lib/main.js',
            file: 'main.js',
            manifest: `${process.env.GATSBY_CDN_BASE_URL}/contact-flow-module/manifest.json`,
          },
        },
      ],
    ],
  ],
};
